import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import allBuildingsReducer from "store/slices/allBuildings/allBuildingsSlice";
import dynamicDashboardReducer from "store/slices/allBuildings/dynamicDashboard/dynamicDashboardSlice";
import energyPerformanceReducerNew from "store/slices/energyPerformance/energyPerformanceSliceNew";
import routeNameReducer from "store/slices/routeName/routeNameSlice";
import techDataReducer from "store/slices/techData/techDataSlice";
import userReducer from "store/slices/user/userSlice";

const combinedReducer = combineReducers({
  allBuildings: allBuildingsReducer,
  dynamicDashboard: dynamicDashboardReducer,
  energyPerformanceNew: energyPerformanceReducerNew,
  routeName: routeNameReducer,
  techData: techDataReducer,
  user: userReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "unauthorizedLogout") {
    return { user: { user: undefined } };
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  reducer: rootReducer,
});
